
	<nav class="navbar is-light">
		<div class="navbar-brand">
			<div class="navbar-item">
				<img :src="`${path}/img/${logoFilename}`" alt="Routes Planner logo" />
			</div>
			<div
				:class="['navbar-burger', 'burger', { 'is-active': isMenuActive }]"
				@click="isMenuActive = !isMenuActive"
			>
				<span></span>
				<span></span>
				<span></span>
			</div>
		</div>

		<div :class="['navbar-menu', { 'is-active': isMenuActive }]">
			<div class="navbar-start">
				<!-- <a class="navbar-item" :href="clientCompanyWebsite" target="_blank">
          <span class="icon">
            <i class="mdi">link</i>
          </span> 
          Strona firmowa
        </a> -->
				<router-link
					:to="{ name: 'orders' }"
					class="control navbar-item navbar-item--orders"
					:class="{ 'is-active': currentView === 'orders' }"
					v-if="isAdmin"
				>
					<span class="icon"><i class="mdi">location_on</i></span>
					<span>Zamówienia</span>
				</router-link>
        <router-link
            :to="{ name: 'PermanentPoints' }"
            class="control navbar-item navbar-item--permanent-points"
            :class="{ 'is-active': currentView === 'PermanentPoints' }"
            v-if="isAdmin"
        >
          <span class="icon"><i class="mdi">assistant_photo</i></span>
          <span>Punkty stałe</span>
        </router-link>
        <router-link
            :to="{ name: 'PlanRoute' }"
            class="control navbar-item navbar-item--plan"
            :class="{ 'is-active': currentView === 'PlanRoute' }"
            v-if="isAdmin"
        >
          <span class="icon"><i class="mdi">edit_location</i></span>
          <span>Zaplanuj trasę</span>
        </router-link>
				<router-link
					:to="{ name: 'users' }"
					class="control navbar-item navbar-item--users"
					:class="{ 'is-active': currentView === 'users' }"
					v-if="isAdmin"
				>
					<span class="icon"><i class="mdi">people_outline</i></span>
					<span>Użytkownicy</span>
				</router-link>
			</div>
			<div class="navbar-end">
				<div class="navbar-item">
					<div class="field is-grouped">
						<button
							@click.prevent="$emit('new-order-click')"
							class="bd-tw-button button is-primary control button--new-order"
							v-if="currentView === 'orders'"
						>
							<span class="icon"><i class="mdi">note_add</i></span>
							<span>Nowe zamówienie</span>
						</button>
						<button
							@click="$emit('new-user-click')"
							class="bd-tw-button button is-primary control button--new-user"
							v-if="isAdmin && currentView === 'users'"
						>
							<span class="icon"><i class="mdi">person_add</i></span>
							<span>Nowy użytkownik</span>
						</button>
            <button
                @click.prevent="$emit('new-permament-point-click')"
                class="bd-tw-button button is-primary control button--new-permanent-point"
                v-if="currentView === 'PermanentPoints'"
            >
              <span class="icon"><i class="mdi">add_location</i></span>
              <span>Nowy punkt</span>
            </button>
						<button
							@click.prevent="$emit('logout-click')"
							class="bd-tw-button button is-danger control button--logout"
						>
							<span class="icon"><i class="mdi">power_settings_new</i></span>
							<span
								>Wyloguj <small>({{ user ? user.name : '?' }})</small></span
							>
						</button>
					</div>
				</div>
			</div>
		</div>
	</nav>
